import configStorage from '../configuration/config-storage';
import translations from './translations';

const t = (key, context) => {
  const config = configStorage.get();
  const locale = config.locale.toLowerCase();

  const string = translations?.[locale]?.[key] || key;

  if (!context || !string) return string;

  return Object.keys(context).reduce(
    (sum, replace) => sum.replace(new RegExp(`{${replace}}`, 'g'), context[replace]),
    string
  );
};

export default t;
